(function () {
  class ScrollContainer extends PIXI.Container {
    constructor() {
      super();

      Reflex.registerEventHandler("ready", this.onReady.bind(this));
    }

    onReady = function () {
      //Scroll Bar: Regular, Hover, Pressed
      this.tints = [0xffffff, 0xc5d1d6, 0x6d94a6];

      //Scroll Background
      this.backgroundColour = 0x2d2d36;

      //Vertical size of all content to be shown
      this.allContentHeight = 0;

      //Stuff that might not appear
      this.itemContainers = [];
      this.itemPositions = [];

      const containerBuffer = 150;
      this.addItems(
        resourceManager.get(
          "helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer"
        ),
        containerBuffer
      );

      this.allContentHeight -= this.amountRemove;

      //Sizes of actual scroll window
      this.scrollMax = 1280;
      this.scrollMin = 720;

      //Scrollbar width & height, radius is how round the top/bottom is
      this.scrollBarTotalHeight = 600;
      this.scrollBarWidth = 12;
      this.scrollBarRadius = 6;

      this.scrollBarHeight =
        (this.scrollMin / this.allContentHeight) * this.scrollBarTotalHeight;
      this.maxScrollBar = this.scrollBarTotalHeight - this.scrollBarHeight;

      this.scrollProgress = 0;

      this.scrollContainer = resourceManager.get(
        "helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer"
      );

      this.mask = resourceManager.get(
        "helpPageScrollContainer:helpPageScroll:scrollArea:scrollMask"
      );
      this.mask.beginFill(0xffffff).drawRect(0, 0, 1, 1).endFill();

      this.mask.width = this.scrollMax;
      this.mask.height = this.scrollMin;
      this.scrollContainer.mask = this.mask;

      this.scrollBarBackground = resourceManager.get(
        "helpPageScrollContainer:helpPageScroll:scrollBarContainer:scrollBarBackground"
      );
      this.scrollBarBackground.beginFill(this.backgroundColour);
      this.scrollBarBackground.drawRoundedRect(
        0,
        0,
        this.scrollBarWidth,
        this.scrollBarTotalHeight,
        this.scrollBarRadius
      );
      this.scrollBarBackground.endFill();

      this.scrollBar = resourceManager.get(
        "helpPageScrollContainer:helpPageScroll:scrollBarContainer:scrollBar"
      );
      this.scrollBar.beginFill(this.tints[0]);
      this.scrollBar.drawRoundedRect(
        0,
        0,
        this.scrollBarWidth,
        this.scrollBarHeight,
        this.scrollBarRadius
      );
      this.scrollBar.endFill();

      this.backgroundFreeSpins = resourceManager.get(
        "helpPageScrollContainer:helpPageScroll:backgroundFreeSpins"
      );
      this.backgroundFreeSpins.alpha = 0;

      this.closeButton = resourceManager.get(
        "helpPageScrollContainer:helpPageScroll:closeButton"
      );
      this.closeButton.interactive = true;
      this.closeButton.mousedown = () => this.close();
      this.closeButton.touchstart = () => this.close();

      this.areaDown = false;
      this.barDown = false;
      this.barOver = false;
      this.lastPos = null;
      this.lastDiffence = null;
      this.scrollAnim = null;

      const self = this;

      this.touchArea = resourceManager.get(
        "helpPageScrollContainer:helpPageScroll:touchArea"
      );
      this.touchArea.beginFill(0xffffff);
      this.touchArea.lineStyle(0, 0xffffff);
      this.touchArea.drawRect(0, 0, 1, 1);
      this.touchArea.scale.x = 1260;
      this.touchArea.scale.y = 700;
      this.touchArea.x = 10;
      this.touchArea.y = 10;
      this.touchArea.interactive = true;
      this.touchArea.alpha = 0;

      this.touchArea.on("mouseout", function (e) {
        self.areaMouseUp(e);
      });

      this.touchArea.mousemove = (e) => this.areaMouseMove(e);
      this.touchArea.mousedown = (e) => this.areaMouseDown(e);
      this.touchArea.mouseup = (e) => this.areaMouseUp(e);
      this.touchArea.mouseupoutside = (e) => this.areaMouseUp(e);
      this.touchArea.touchmove = (e) => this.areaMouseMove(e);
      this.touchArea.touchstart = (e) => this.areaMouseDown(e);
      this.touchArea.touchend = (e) => this.areaMouseUp(e);
      this.touchArea.touchendoutside = (e) => this.areaMouseUp(e);

      this.scrollBarContainer = resourceManager.get(
        "helpPageScrollContainer:helpPageScroll:scrollBarContainer"
      );

      this.scrollBarContainer.interactive = true;
      this.scrollBarContainer.touchmove = (e) => this.barMouseMove(e);
      this.scrollBarContainer.mousemove = (e) => this.barMouseMove(e);
      this.scrollBarContainer.mousedown = (e) => this.barMouseDown(e);
      this.scrollBarContainer.mouseup = (e) => this.barMouseUp(e);
      this.scrollBarContainer.mouseupoutside = (e) => this.barMouseUp(e);
      this.scrollBarContainer.touchstart = (e) => this.barMouseDown(e);
      this.scrollBarContainer.touchend = (e) => this.barMouseUp(e);
      this.scrollBarContainer.touchendoutside = (e) => this.barMouseUp(e);

      this.scrollBarContainer.on("mouseover", function (e) {
        self.barOver = true;

        if (!self.barDown) {
          self.scrollBar.tint = self.tints[1];
        }
      });
      this.scrollBarContainer.on("mouseout", function (e) {
        self.barOver = false;

        if (!self.barDown) {
          self.scrollBar.tint = self.tints[0];
        }
      });

      //PIXI v4 doesn't seem to support mouse wheel so using event listener
      addEventListener("wheel", (e) => this.areaMouseWheel(e));

      this.visible = false;

      Reflex.registerEventHandler(
        "orientationChange",
        this.orientationChange.bind(this)
      );

      messageBus.subscribe("game:modal", this.onModal.bind(this));

      this.orientationChange();
    };

    barMouseDown(e) {
      const { originalEvent } = e.data;
      const clientY = !originalEvent.touches
        ? originalEvent.clientY
        : originalEvent.touches[0].clientY;

      if (this.scrollAnim) {
        this.scrollAnim.kill();
      }

      this.lastPos = {
        y: clientY,
      };

      this.scrollBar.tint = this.tints[2];
      this.barDown = true;
    }

    barMouseUp(e) {
      this.scrollBar.tint = this.barOver ? this.tints[1] : this.tints[0];
      this.barDown = false;
      this.areaDown = false;
    }

    barMouseMove(e) {
      const { originalEvent } = e.data;
      var clientY = !originalEvent.touches
        ? originalEvent.clientY
        : originalEvent.touches[0].clientY;

      if (!clientY || !this.lastPos) return;

      if (this.barDown) {
        this.lastDiffence = clientY - this.lastPos.y;
        this.lastPos.y = clientY;

        const yPos = this.scrollBarContainer.y;
        const min = this.scrollBarTotalHeight;
        const max = gdk.getScreenHeight() - yPos;
        const pos = (min / max) * (clientY - yPos);

        this.scrollBar.y = pos;

        this.barCap();
        this.scrollProgress = this.scrollBar.y / this.maxScrollBar;
        this.setAreaProgress();
      }
    }

    orientationChange() {
      if (systemData.isLandscape) {
        this.mask.width = this.scrollMax;
        this.mask.height = this.scrollMin;

        this.touchArea.scale.x = 1260;
        this.touchArea.scale.y = 700;
        this.touchArea.x = 10;
        this.touchArea.y = 10;
      } else {
        this.mask.width = this.scrollMin;
        this.mask.height = this.scrollMax;

        this.touchArea.scale.x = 700;
        this.touchArea.scale.y = 1260;
        this.touchArea.x = 10;
        this.touchArea.y = 10;
      }

      for (let i = 0; i < this.itemContainers.length; i++) {
        this.itemContainers[i].y = this.itemPositions[i];
      }

      this.setAreaProgress();
      this.scrollDistanceCap();
    }

    open() {
      this.visible = true;

      messageBus.post("game:modal", {
        reason: "Options menu open",
      });

      this.scrollProgress = 0;
      this.setAreaProgress();
      this.setBarProgress();

      this.updateFairnessText();
    }

    updateFairnessText() {
      this._fairnessText = resourceManager.get(
        "helpPageScrollContainer:helpPageScroll:scrollArea:scrollContainer:rtpMaxWin:rtp"
      );

      var stakeController = resourceManager.getController("stakeController");
      var stake = stakeController.CurrentStake;
      var stakeIndex = stakeController.SelectedStakeIndex;
      var baseStake =
        stakeController.CurrentBetPerLine * stakeController.CurrentWinLineCount;
      var rtp = gameData.slotConfig.RTP[stakeIndex] * 100;

      this._fairnessText.setTranslationParameters(
        gdk.formatCurrency(stake),
        gdk.formatCurrency(baseStake * gameData.maxExposure),
        rtp.toFixed(1) + "%"
      );

      const versionText = resourceManager.get(
        "helpPageScrollContainer:helpPageScroll:versionText"
      );
      const versionStr =
        "v " +
        gameData.gameVersionMajor +
        "." +
        gameData.gameVersionMinor +
        "." +
        gameData.gameVersionBugFix +
        " - " +
        gameData.gameMathsVersion +
        "\n(" +
        gameData.gameReleaseDate +
        ")";
      versionText.setText(versionStr);
    }

    close() {
      this.visible = false;

      messageBus.post("game:modal", {});

      soundManager.play("buttonPressed");
    }

    setAreaProgress() {
      this.scrollContainer.y = -this.allContentHeight * this.scrollProgress;

      this.animateBackground();
    }

    setBarProgress() {
      if (this.scrollContainer.y == 0) {
        this.scrollProgress = 0;
      } else {
        this.scrollProgress = -this.scrollContainer.y / this.allContentHeight;
      }

      this.animateBackground();

      this.scrollBar.y =
        this.scrollProgress *
        (this.scrollBarTotalHeight - this.scrollBarHeight);
    }

    animateBackground() {
      this.backgroundFreeSpins.alpha = this.scrollProgress;
    }

    areaMouseWheel(e) {
      if (
        this.scrollContainer.y <= 0 &&
        -this.scrollContainer.y <= this.allContentHeight
      ) {
        this.scrollContainer.y -= e.deltaY;
      }

      this.scrollDistanceCap();
    }

    barCap() {
      this.scrollBar.y = Math.min(
        Math.max(this.scrollBar.y, 0),
        this.maxScrollBar
      );
    }

    scrollDistanceCap() {
      this.scrollContainer.y = Math.min(
        Math.max(this.scrollContainer.y, -this.allContentHeight),
        0
      );

      this.setBarProgress();
    }

    areaMouseMove(e) {
      const { originalEvent } = e.data;
      var clientY = !originalEvent.touches
        ? originalEvent.clientY
        : originalEvent.touches[0].clientY;

      if (!clientY || !this.lastPos) return;

      if (this.areaDown && !this.barDown) {
        this.lastDiffence = clientY - this.lastPos.y;
        this.lastPos.y = clientY;

        if (
          this.scrollContainer.y <= 0 &&
          -this.scrollContainer.y <= this.allContentHeight
        ) {
          this.scrollContainer.y += this.lastDiffence;
        }

        this.scrollDistanceCap();
      }
    }

    areaMouseDown(e) {
      const { originalEvent } = e.data;
      const clientY = !originalEvent.touches
        ? originalEvent.clientY
        : originalEvent.touches[0].clientY;
      this.areaDown = true;

      if (this.scrollAnim) {
        this.scrollAnim.kill();
      }

      this.lastPos = {
        y: clientY,
      };
    }

    areaMouseUp() {
      const minSpeed = 5;

      const duration = Math.abs(this.lastDiffence / 50);

      const gotoY = Math.min(
        Math.max(
          this.scrollContainer.y + this.lastDiffence * 20,
          -this.allContentHeight
        ),
        0
      );

      if (this.lastDiffence != null) {
        if (Math.abs(this.lastDiffence) > minSpeed) {
          this.scrollAnim = gsap.to(this.scrollContainer, {
            duration,
            y: gotoY,
            ease: "power2.out",
            onUpdate: () => {
              this.scrollDistanceCap();
            },
          });
        }
      }

      this.areaDown = false;

      if (!this.barOver) {
        this.lastPos = null;
        this.lastDiffence = null;
        this.scrollBar.tint = this.tints[0];
        this.barDown = false;
      }
    }

    addItems(container, buffer) {
      const items = container.children[0].children;

      this.amountRemove = 0;

      if (items.length === 0) return;

      for (let i = 0; i < items.length; i++) {
        const item = items[i];

        const condition = item.children[0].parent.Props.condition;
        const customBuffer = item.children[0].parent.Props.customBuffer;

        let height = item.height;

        if (customBuffer) {
          height += customBuffer;
          this.amountRemove += customBuffer;
        } else {
          height += buffer;
        }

        this.addItem(condition, item, height);
      }
    }

    addItem(condition, item, size) {
      if (this.checkCondition(condition)) {
        this.itemPositions.push(this.allContentHeight);
        this.itemContainers.push(item);
        this.allContentHeight += size;
      } else {
        item.visible = false;
      }
    }

    checkCondition(condition) {
      if (condition === undefined) {
        return true;
      }

      return eval(condition);
    }

    onModal(data) {
      if (this.visible) {
        if (data.reason === undefined) {
          messageBus.post("game:modal", {
            reason: "Options menu open",
          });
        }
      }
    }
  }

  let scrollContainerCreator = function (json) {
    return new ScrollContainer();
  };

  resourceManager.registerObjectType(
    "scrollContainer",
    scrollContainerCreator,
    function () {},
    function () {
      return [];
    }
  );
})();
